"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var homepageApi_1 = require("../mock/homepageApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var homepageApi = {
    getOtherMemebersCompleted: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockLessons; },
            url: "".concat(coreServiceUrl, "/lessons/other-members-completed"),
            token: token,
        });
    },
    getOtherMemebersTaken: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockOtherMemebersTaken; },
            url: "".concat(coreServiceUrl, "/other-members-taking"),
            token: token,
        });
    },
    getRecentlyAdded: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockeRecentlyAddedContent; },
            url: "".concat(coreServiceUrl, "/home/recently-added"),
            token: token,
        });
    },
    getMyCompletedCourses: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockCourses; },
            url: "".concat(coreServiceUrl, "/courses/my-completed-courses"),
            token: token,
        });
    },
    getMyCompletedContent: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockCompletedData; },
            url: "".concat(coreServiceUrl, "/home/my-completed-content"),
            token: token,
        });
    },
    getAssignedContent: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockAssignedContent; },
            url: "".concat(coreServiceUrl, "/home/assigned-content"),
            token: token,
        });
    },
    getLeanContent: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockLeanContent; },
            url: "".concat(coreServiceUrl, "/home/lean-content"),
            token: token,
        });
    },
    getUserLeaderboard: function (token, options) {
        var search = options.search, offset = options.offset, limit = options.limit, teamUuid = options.teamUuid;
        var queryParams = new URLSearchParams(__assign(__assign(__assign(__assign({}, (search !== undefined && { search: search })), (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (teamUuid !== undefined && { teamUuid: teamUuid })));
        var params = queryParams.toString();
        var url = "".concat(coreServiceUrl, "/home/users-leaderboard").concat(params ? "?".concat(params) : '');
        return rest_1.default.get({
            mockFunc: function () { return (limit ? homepageApi_1.mockTopUsersLeaderboarddData : homepageApi_1.mockUsersLeaderboarddData); },
            url: url,
            token: token,
        });
    },
    getTeamsLeaderboard: function (token, options) {
        var search = options.search, offset = options.offset, limit = options.limit;
        var queryParams = new URLSearchParams(__assign(__assign(__assign({}, (search !== undefined && { search: search })), (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })));
        var params = queryParams.toString();
        var url = "".concat(coreServiceUrl, "/home/teams-leaderboard").concat(params ? "?".concat(params) : '');
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockTeamsLeaderboarddData; },
            url: url,
            token: token,
        });
    },
    getHomepageBanners: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockHomePageBanners; },
            url: "".concat(coreServiceUrl, "/home/all"),
            token: token,
        });
    },
};
exports.default = homepageApi;
